<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Edit festival provider") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('MESSAGES.Festival provider image')"
            @selectImage="selectImage"
            :preSelectedImage="data.media?.path"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival provider arabic name')"
            v-model.trim="data.nameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival provider english name')"
            v-model.trim="data.nameEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          />
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobileNumber')"
            v-model.trim="data.mobile"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Commission percentage from the center')"
            v-model.trim="data.commission"
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("MESSAGES.centerOwnerData") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.centerOwnerName')"
            v-model.trim="data.owner_name"
            required
          />
          <base-image-upload-input
            col="6"
            identifier="owner_image"
            :placeholder="$t('PLACEHOLDERS.centerOwnerImage')"
            @selectImage="selectOwnerImage"
            :preSelectedImage="data.owner_media?.path"
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("PLACEHOLDERS.contacts") }}</h4>
          </div>
          <div class="col-12">
            <label class="form-label mb-2">{{
              $t("PLACEHOLDERS.contactPhoneNumbers")
            }}</label>
          </div>
          <div class="col-12">
            <div class="add_another d-inline-flex mb-3" @click="addPhoneRow">
              <i class="fas fa-plus"></i>
            </div>
          </div>
          <div
            class="col-lg-6 col-12"
            v-for="(item, index) in phone_numbers"
            :key="'phone-' + index"
          >
            <div class="item d-flex align-items-center">
              <base-input
                class="w-100"
                type="tel"
                :placeholder="$t('PLACEHOLDERS.contactPhoneNumber')"
                v-model.trim="item.phone"
              />
              <div class="all_actions" v-if="phone_numbers.length > 1">
                <span class="add_another" @click="removePhoneRow(index)">
                  <i class="fas fa-minus"></i>
                </span>
              </div>
            </div>
          </div>
          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.whatsapp_number"
          />

          <div class="col-12 mt-3">
            <h4>{{ $t("MESSAGES.socialMediaLinks") }}</h4>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.social_media_links.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.social_media_links.instagram"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snapchat')"
            v-model.trim="data.social_media_links.snapchat"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.twitter_link')"
            v-model.trim="data.social_media_links.x"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok')"
            v-model.trim="data.social_media_links.tiktok"
          />
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseMultiImageUploadInput from "../../../components/formInputs/BaseMultiImageUploadInput.vue";
import BaseNamePreviewFileUploadInput from "../../../components/formInputs/BaseNamePreviewFileUploadInput.vue";
import ChangableMapComponent from "@/components/general/ChangableMapComponent";
import { validateFestivalProviderFields } from "@/utils/festivalProviderValidation";

export default {
  name: "EditFestivalProviders",

  components: {
    BaseMultiImageUploadInput,
    BaseNamePreviewFileUploadInput,
    ChangableMapComponent,
  },
  data() {
    return {
      isWaitingRequest: false,
      sections: [],
      store: null,
      store_waiting: null,
      file: null,
      fileType: "",
      AddimgUrls: [],
      files: [],
      additionalImages: [],
      imageId: [],
      imgUrls: [],
      phone_numbers: [{ phone: "" }],
      data: {
        section_id: null,
        media: {
          path: null,
          file: null,
        },
        owner_media: {
          path: null,
          file: null,
        },
        email: null,
        owner_name: null,
        mobile: null,
        commission: 0,
        whatsapp_number: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        active: true,
        featured_tag: null,
        lat: 0,
        lng: 0,
        AddimgUrls: [],
        social_media_links: {
          facebook: null,
          instagram: null,
          tiktok: null,
          x: null,
          snapchat: null,
        },
        additionalImages: [],
        imageId: [],
        imgUrls: [],
      },
      dropdownOptions: {},
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    setLocation(event, index) {
      this.data.lat = event.latLng.lat();
      this.data.lng = event.latLng.lng();
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        this.data.lat = this.currentPlace.geometry.location.lat();
        this.data.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },
    onFileSelectField(files) {
      this.data.additionalImages = files;
    },
    onFileRemoveField(index) {
      this.$delete(this.data.imgUrls, index);
    },

    async getStoreData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `festival-providers/${this.$route.params?.id}`,
        });
        this.data.nameAr = res.data.data.FestivalProvider.name_ar;
        this.data.nameEn = res.data.data.FestivalProvider.name_en;
        this.data.descProd = res.data.data.FestivalProvider.description_ar;
        this.data.descProdEn = res.data.data.FestivalProvider.description_en;
        this.data.media.path = res.data.data.FestivalProvider.logo;
        this.data.active = res.data.data.FestivalProvider.is_active;
        this.data.email = res.data.data.FestivalProvider.email;
        this.data.owner_name = res.data.data.FestivalProvider.owner_name;
        this.data.mobile = res.data.data.FestivalProvider.mobile;
        this.data.commission = res.data.data.FestivalProvider.commission ?? 0;
        this.data.whatsapp_number =
          res.data.data.FestivalProvider.whatsapp_number;
        this.data.owner_media.path =
          res.data.data.FestivalProvider.owner_image;
        if (res.data.data.FestivalProvider.phone_numbers?.length) {
          this.phone_numbers = res.data.data.FestivalProvider.phone_numbers.map(
            (phone) => ({ phone })
          );
        }
        this.data.social_media_links =
          res.data.data.FestivalProvider.social_media_links;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    selectImage(selectedImage) {
      this.data.media = selectedImage;
    },

    selectOwnerImage(selectedImage) {
      this.data.owner_media = selectedImage;
    },

    addPhoneRow() {
      this.phone_numbers.push({ phone: "" });
    },

    removePhoneRow(index) {
      this.phone_numbers.splice(index, 1);
    },
    async AdddonFileRemove(index) {
      if (this.files.length > 1) {
        this.$delete(this.files, index);
      }
      // this.$delete(this.imageId, index);

      // Get the imageId from the 'imageId' array using the index
      const imageId = this.imageId[index];

      // Make sure the imageId is valid before proceeding
      if (!imageId) {
        console.error("Image ID not found.");
        return;
      }

      // Remove the image URL from imgUrls
      // if(this.AddimgUrls.length > 1){
      //   this.$delete(this.AddimgUrls, index);
      // }

      // Remove the image from additionalImages
      // if(this.additionalImages.length > 1){
      //   this.$delete(this.additionalImages, index);
      // }

      try {
        // Send a delete request to the API using the imageId
        await this.$axios({
          method: "GET",
          url: `/delete-file/${imageId}`, // Use imageId in the URL for deletion
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // async fetchDropdownOptions(fieldId) {
    //   try {
    //     const res = await this.$axios.get(`/dropdown-options/${fieldId}`);
    //     this.dropdownOptions[fieldId] = res.data.options;
    //   } catch (error) {
    //     console.error("Error fetching dropdown options", error);
    //   }
    // },

    validateFormInputs() {
      const validationError = validateFestivalProviderFields(
        this.data.mobile,
        this.data.commission,
        this.data.owner_name,
        null,
        null,
        this.$t.bind(this),
        { passwordRequired: false }
      );

      if (validationError) {
        this.$message.error(validationError);
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Basic fields
      REQUEST_DATA.append("_method", "put");
      REQUEST_DATA.append("owner_name", this.data.owner_name ?? "");
      REQUEST_DATA.append("name[ar]", this.data.nameAr);
      REQUEST_DATA.append("name[en]", this.data.nameEn);
      REQUEST_DATA.append("description[ar]", this.data.descProd);
      REQUEST_DATA.append("description[en]", this.data.descProdEn);
      if (this.data.media.file)
        REQUEST_DATA.append("logo", this.data.media.file);
      if (this.data.owner_media.file)
        REQUEST_DATA.append("owner_image", this.data.owner_media.file);

      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("country_code", "966");
      REQUEST_DATA.append("mobile", this.data.mobile ?? "");
      REQUEST_DATA.append("commission", this.data.commission ?? 0);

      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      this.phone_numbers.forEach((element, index) => {
        if (String(element.phone ?? "").trim()) {
          REQUEST_DATA.append(`phone_numbers[${index}]`, element.phone);
        }
      });

      REQUEST_DATA.append(
        "whatsapp_number",
        this.data.whatsapp_number ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[facebook]",
        this.data.social_media_links.facebook ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[instagram]",
        this.data.social_media_links.instagram ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[tiktok]",
        this.data.social_media_links.tiktok ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[x]",
        this.data.social_media_links.x ?? ""
      );
      REQUEST_DATA.append(
        "social_media_links[snapchat]",
        this.data.social_media_links.snapchat ?? ""
      );
      try {
        await this.$axios({
          method: "POST",
          url: `festival-providers/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        // this.files = []
        this.$forceUpdate();
        // this.getStoreData();

        this.$router.push({ path: "/festival-providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    change_fields() {
      this.data.store_field = []; // Reset store fields
      // Load the new fields for the selected section
      if (this.data.section_id) {
        console.log("this.sections", this.sections);
        console.log("this.data.section_id", this.data.section_id?.id);
        const selectedSection = this.sections.find(
          (section) => section.id == this.data.section_id?.id
        );
        if (selectedSection) {
          console.log("resss", this.data.store_field);
          this.data.store_field = selectedSection.fields || []; // Assign new fields for the section
        }
      }
    },
  },
  created() {
    this.getStoreData();
  },
};
</script>
